import React from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import HormoneHero from './components/HormoneHero';
import TreatmentOptions from './components/TreatmentOptions';
import BenefitsSection from './components/BenefitsSection';
import ProcessSection from './components/ProcessSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import TestimonialsSection from './components/TestimonialsSection';

const HormoneOptimizationPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HormoneHero />
      <TreatmentOptions />
      <BenefitsSection />
      <ProcessSection />
      <PricingSection />
      <TestimonialsSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default HormoneOptimizationPage;